/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/display-name */
/* eslint-disable import/no-cycle */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from '../store';
import {
    loadPage,
    insertAtividades,
    setGuiasPesquisa,
} from '../store/ducks/pageConfig';
import { ParametrosAPI } from '../shared/http-requests';
import { APIHelper } from '../shared/helpers';
import { loadInstitutionData } from '../store/ducks/instituicao';
import LoadingPage from '../modules/consulta/components/LoadingPage';
import { usePrefiterParams } from '../shared/hooks';

const MiddlewareLogin =
    ComponentToWrap =>
    ({ rewriteLoading, ...restProps }) => {
        const dispatch = useDispatch();
        const { initPrefilters } = usePrefiterParams();
        const pageConfig = useSelector(state => state.pageConfig);
        // public credentials removed from system
        const instituicao = useSelector(state => state.instituicao.data);

        useEffect(() => {
            if (!pageConfig.status) {
                const loadData = async () => {
                    if (!pageConfig.atividades?.length) {
                        await ParametrosAPI.buscarFuncionalidades()
                        .then(response => {
                            dispatch(
                                insertAtividades(response.data),
                            );
                        })
                        .catch(error => APIHelper.tratarErro(error));
                    }
                    
                    if (!instituicao) {
                        await ParametrosAPI.buscarInstituicao()
                        .then(response => {
                            dispatch(loadInstitutionData(response.data));
                        })
                        .catch(error => APIHelper.tratarErro(error));   
                    }

                    if (!pageConfig.guiasPesquisa?.length) {
                        await ParametrosAPI.buscarDadosSecao1()
                        .then(response =>
                            dispatch(setGuiasPesquisa(response.data)),
                        )
                        .catch(error => APIHelper.tratarErro(error));
                    }
                    initPrefilters();
                    dispatch(loadPage(true));
                };
                loadData();
            }
        }, []);

        if (pageConfig.status)
            return (
                <ComponentToWrap
                    instituicao={instituicao}
                    pageConfig={pageConfig}
                    rewriteLoading={rewriteLoading}
                    {...restProps}
                />
            );
        if (rewriteLoading && typeof rewriteLoading === 'function')
            return rewriteLoading();

        return <LoadingPage />;
    };

export default MiddlewareLogin;
